// @ts-nocheck
import React from 'react'
import cx from 'classnames'

import {
  Dropdown,
  DropdownPropsContext,
} from 'components/shared/Dropdown/Dropdown'
import { Icon, MoreVerticalIcon } from 'components/shared/Icon/Icon'

import { ICON_SIZES } from './model'

import styles from './DropdownAnchor.module.scss'

export const DropdownAnchor = ({
  ariaLabel,
  className = undefined,
  icon = MoreVerticalIcon,
  isDisabled = false,
  size,
}) => {
  const { isToggled } = React.useContext(DropdownPropsContext)

  return (
    <Dropdown.Anchor
      className={cx(styles.anchor, styles.size, {
        [styles[size]]: Boolean(size),
        [styles.active]: isToggled,
        [className]: Boolean(className),
      })}
      {...{ ariaLabel, size, isDisabled }}
    >
      <Icon className={styles.icon} size={ICON_SIZES[size]} {...{ icon }} />
    </Dropdown.Anchor>
  )
}
